import { IComponentController } from 'angular';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';//
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IEcranContextController } from '../../../../../core/behaviors/ex-ecran-context/ex-ecran-context.behavior';
import { IMenuItemClass } from '../../../../../core/services/menu/menu-item.service';
import IDialogService = angular.material.IDialogService;
import { IDataItemCatalogue } from '../../../../../core/components/ex-input-item-catalogue/ex-input-item-catalogue.controller';
import { IDefaultsService } from '../../../../../core/services/utils/defaults.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IStateParamsService } from 'angular-ui-router';

interface IPageAc0058 extends IComponentController {
    ecranContextCtrl: IEcranContextController;
    multiOccurrence: IMultiOccurrence
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    edeMultiOccurrence: IMultiOccurrence;
    edeMultiOccurrenceOptions: IMultiOccurrenceOptions;
    uhcMultiOccurrence: IMultiOccurrence;
    uhcMultiOccurrenceOptions: IMultiOccurrenceOptions;
    doccleint: number;
    valeursEcran: any;
    confirm(event: any, data: { refcleint: number; refcod: string; refnom: string; }): void;
    hasEntente(): boolean;
    multiOccurrencesIsReady(): boolean;
}


/* @ngInject */
export default function Ac0058Controller(Menu: IMenuClass,
    MenuItem: IMenuItemClass,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    $mdDialog: IDialogService,
    defaults: IDefaultsService,
    ecranDetails: IEcranDetailsResourcesEntite,
    $stateParams: IStateParamsService) {

    const vm: IPageAc0058 = this;
    vm.confirm = confirm;
    vm.hasEntente = hasEntente
    vm.valeursEcran = ecranDetails
    vm.multiOccurrencesIsReady = multiOccurrencesIsReady
    vm.$onInit = function $onInit() {
        defaults(vm, {
            doccleint: $stateParams.doccleint
        });

        vm.monoOccurrenceOptions = {
            id: vm.doccleint
        };

        const criteresSuggeres = new Formulaire([
            new FormulaireItem('uhcdsc', { default: $stateParams.value }),
            new FormulaireItem('uhcnumcat')
        ], { largeurDefaut: 30 })

        vm.multiOccurrenceOptions = {
            srccod: "ac0058",//important afin d'obtenir les datatypes et les libelles
            isTab: true,
            autoFetch: true,
            fonctions: {
                customCriteresSuggeres: true,
                enregistrerUnEtat: false,
                selectionnerUnEtat: false,
                recherche: false,
                filtrer: false,
                selectionnerDesColonnes: false,
                selectionnerTri: false,
                avisEmploye: false,
                criteresSuggeresVisibles: true,
                reinitialiserOuvrirCriteres: true,
                effaceCriteres: true
            },
            criteresSuggeres: criteresSuggeres,
            colonnesVisibles: [
                { nom: 'uhcdsc', largeur: 16 },
                { nom: 'uhcnumcat', largeur: 16 }
            ]
        }

        vm.uhcMultiOccurrenceOptions = {
            isTab: true,
            autoFetch: true,
            tabSelected: !vm.hasEntente(),
            bloc: 'uhc',
            actionsRangeeDroite: new Menu([new MenuItem(confirm, {
                icon: 'check_circle',
                iconButton: true
            })]),
            fonctions: {
                edition: false,
                nouveau: false,
                customCriteresSuggeres: true,
                rechercheCollapsable: false,
                effaceCriteres: true,
                pagination: true
            },
            criteresSuggeres,
            pagination: {
                nombreElementPage: 100,
                nbElementsPossibles: [100, 250, 500]
            },
            colonnesVisibles: [
                { nom: 'uhcdsc', largeur: 150 },
                { nom: 'uhcnumcat', largeur: 150 },
                { nom: 'uhcprxuni', largeur: 150 }
            ],
            colonnesCachees: []
        };

        vm.edeMultiOccurrenceOptions = {
            isTab: true,
            tabSelected: vm.hasEntente(),
            bloc: 'ede',
            autoFetch: true,
            actionsRangeeDroite: new Menu([new MenuItem(confirm, {
                icon: 'check_circle',
                iconButton: true
            })]),
            fonctions: {
                edition: false,
                nouveau: false,
                customCriteresSuggeres: true,
                rechercheCollapsable: false,
                effaceCriteres: true,
                pagination: true
            },
            criteresSuggeres,
            pagination: {
                nombreElementPage: 100,
                nbElementsPossibles: [100, 250, 500]
            },
            colonnesVisibles: [
                { nom: 'uhcdsc', largeur: 150 },
                { nom: 'uhcnumcat', largeur: 150 },
                { nom: 'procod', largeur: 150 },
                { nom: 'prxneg', largeur: 150 },
                { nom: 'mntmax', largeur: 150 },
                { nom: 'mntcon', largeur: 150 },
                { nom: 'qtemax', largeur: 150 },
                { nom: 'qtecon', largeur: 150 },
                { nom: 'caacod', largeur: 150 },
                { nom: 'caadsc', largeur: 150 },
                { nom: 'forcod', largeur: 150 },
                { nom: 'fordsc', largeur: 150 },
            ],
            colonnesCachees: ['etrcleint']
        };
    }

    function confirm(event: any, values: any) {
        const data: IDataItemCatalogue = {
            id: values.uhccleint,
            description: values.uhcdsc,
            prixUnitaire: values.uhcprxuni || values.prxneg,
            catalogue: values.uhcnumcat,
            idEntente: values.edecleint || undefined
        }

        $mdDialog.hide(data);
    }

    function hasEntente(): boolean {
        return Boolean(vm.valeursEcran.valeurs.etrcleint)
    }

    function multiOccurrencesIsReady(): boolean {
        if ((vm?.edeMultiOccurrence && vm.hasEntente() && vm?.edeMultiOccurrence.initialized)) {
            return true
        }
        if ((vm?.uhcMultiOccurrence && !vm.hasEntente() && vm?.uhcMultiOccurrence.initialized)) {
            return true
        }
        return false;
    }
}
